import { render } from "./CarouselAbout.vue?vue&type=template&id=c2fac804&scoped=true"
import script from "./CarouselAbout.vue?vue&type=script&lang=js"
export * from "./CarouselAbout.vue?vue&type=script&lang=js"

import "./CarouselAbout.vue?vue&type=style&index=0&id=c2fac804&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.39_vue@3.5.39_typescript@5.9.3__webpack@5.109.2_cssna_em6n5doortrigby6mckty5jpxy/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2fac804"]])

export default __exports__